










































































import { Component, Vue, Prop } from 'vue-property-decorator';
import TitlePage from '@/components/Title.vue';
import TabsNav from '@/components/tabs/TabsNavIcons.vue';
import TableBlock from '@/components/data/Table/Table.vue';
import FilterPreview from '@/components/filter/FilterPreview.vue';
import FilterDropDown from '@/components/filter/FilterDropDown.vue';
import AddIcon from '@/components/icons/Add.vue';
import SyncIcon from '@/components/icons/Sync.vue';

import ListLayout from './ListLayout.vue';

import PageBaseModule from '@/store/page';
import FilterModal from '@/store/modals/filter';
import { FilterSettings } from '@/types/filter/filter';
import { TableInterface } from '@/types/page/table';

@Component({
    components: {
        ListLayout,
        TitlePage,
        TabsNav,
        FilterPreview,
        FilterDropDown,
        TableBlock,
        AddIcon,
        SyncIcon,
    },
})
export default class ListTab extends Vue {
    @Prop({ required: true }) readonly repository!: Readonly<PageBaseModule>;
    @Prop({ required: false }) readonly filterSettings?: FilterSettings;
    @Prop({ required: false }) readonly tabsNav?: any;
    @Prop({ required: false }) readonly currentTab?: any;
    @Prop({ required: false }) readonly tabsNavAdditional?: any;
    @Prop({ required: false }) readonly currentTabAdditional?: any;
    @Prop({ default: true }) readonly hasCreateButton!: boolean;
    @Prop({ default: false }) readonly hasSyncButton!: boolean;
    @Prop({ default: true }) readonly showTable!: boolean;
    @Prop({ required: false, default: () => ([]) }) readonly errorRows!: number[];


    focusKey = '' as string;

    get settings() {
        return this.repository.pageSettings;
    }

    get totalItems() {
        return (this.repository.pageSettings.table as TableInterface).totalItems;
    }

    get isShow() {
        return FilterModal.modal.isShow;
    }

    closeFilter() {
        FilterModal.closeModal();
    }

    updateList() {
        this.$emit('updateList');
    }

    toggleFilter(_: any, key: string) {
        FilterModal.toggleModal();
        this.focusKey = key;
    }

    resetFilters() {
        this.$emit('resetFilters');
    }

    toAdd() {
        this.$emit('toAdd');
    }

    toSync() {
        this.$emit('toSync');
    }

    selectAmount(amount: number) {
        const action = this.settings.actionPageAmountItems;

        if (typeof action === 'string') {
            this.$store.dispatch(action, amount);
        }
    }

    actionTable(handler: any) {
        if (handler.action === 'sort') {
            this.repository.sort({ field: handler.field.field, sort: handler.field.sort });
        }

        if (handler.action === 'delete') {
            this.$emit('delete', handler.row);
            this.repository.delete(handler.id);
        }

        if (handler.action === 'download') {
            this.$emit('download', handler.id);
        }
    }

    mounted() {
        this.repository.init();
    }
}
